import { Component } from '@angular/core';
import { ProductBaseComponent } from './product-base.component';

@Component({
    selector: 'app-product-simple[product]',
    template: `
    <div class="pt-1 pb-1 px-1 bg-white mb-1 rounded">
      <div class="d-flex justify-content-between align-items-center py-2 cursor-pointer px-2" (click)="addToCart(product)">
        <div class="d-flex justify-content-start flex-nowrap align-items-center flex-shrink-1 flex-grow-1 w-50 me-2">
          <div class="position-relative me-3">
            <div
              class="product-image-placeholder border-medium border w-56px h-56px position-relative flex-shrink-0"
               [lazyLoad]="product.image ?? ''" [decode]="true">
            </div>
            <span class="position-absolute top-0 start-100 translate-middle" (click)="$event.stopPropagation(); openInfo(product.id)">
              <span class="material-icons text-info">info</span>
            </span>
          </div>

          <div class="text-wrap mw-100 ptsd">
            {{product.title}}
          </div>
        </div>

        <div class="fs-6 d-flex align-items-end justify-content-center flex-column flex-shrink-0 w-25 flex-grow-1">
          <span class="fw-bolder text-info text-nowrap" [style.font-size]="'1rem'">{{product.price | currency}}</span>
          <div class="d-flex justify-content-center align-items-center">
            <span class="text-info d-inline-flex justify-content-center align-items-center px-1" [class.text-danger]="!isProductAvailable()">
              <span class="material-icons icon-size">inventory</span>
              {{product.considersStock ? product.stock : '&#8734;'}}
            </span>
            <span class="text-secondary d-inline-flex justify-content-center align-items-center px-1" *ngIf="product.hasMultipleVariants">
              <span class="material-icons icon-size">sell</span>
              {{product.variants.length}}
            </span>
          </div>
        </div>
      </div>
    </div>
  `,
    styles: [`
    :host {
      display: block;
      width: 100%;
    }
    .icon-size {
      font-size: var(--bs-body-font-size);
    }
  `],
    standalone: false
})
export class ProductSimpleComponent extends ProductBaseComponent {
}
